const NA = 'N/A';
const PERCENT = '%';
const PERCENT_UP = '↑';
const PERCENT_DOWN = '↓';
const REOPOT_ADD = '+';
const REOPOT_LESS = '-';
const THOUNDS = 'K';
const MILLION = 'M';
const BILLION = 'B';

/**
 * 格式化千分位
 * @param {*需要格式化的数字} decimal
 * @param {*} scale
 */
export const fmtThousand = (decimal, scale, keepBit) => {
  if (decimal === null || decimal === false || isNaN(decimal)) {
    return NA;
  }
  if (decimal === 0) {
    return 0;
  }
  let convertedDecimal = keepDecimal(decimal, scale, keepBit);
  let intPart = Math.round(convertedDecimal);
  return String(intPart).length > 3
    ? String(convertedDecimal).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, '$1,')
    : String(convertedDecimal);
};

/**
 * 格式化百分比%（四舍五入取整）
 * @param {*需要格式化的百分比小数} decimal
 * @param {*} scale
 */
export const fmtPercent = (decimal, scale) => {
  if (decimal === null || decimal === false || isNaN(decimal)) {
    return NA;
  }
  let convertedDecimal = keepDecimal(decimal * 100, scale);
  let result = scale ? convertedDecimal : Math.round(convertedDecimal);
  return isNaN(result) ? NA : result + PERCENT;
};

/**
 * 格式化环比百分比%（四舍五入）
 * @param {*需要格式化的百分比小数} decimal
 * @param {*} scale
 */
export const fmtPercentUpDown = (decimal, scale) => {
  if (decimal === null || decimal === false || isNaN(decimal)) {
    return NA;
  }
  let convertedDecimal = keepDecimal(decimal * 100, scale);
  let result = scale ? convertedDecimal : Math.round(convertedDecimal);

  result =
    decimal > 0
      ? result + PERCENT + PERCENT_UP
      : Math.abs(result) + PERCENT + PERCENT_DOWN;

  return isNaN(decimal) ? NA : result;
};
/**
 * 格式化环比百分比%（四舍五入）
 * @param {*需要格式化的百分比小数} decimal
 * @param {*} scale
 */
export const fmtPercentAddLESS = (decimal, scale) => {
  if (decimal === null || decimal === false || isNaN(decimal)) {
    return NA;
  }
  let convertedDecimal = keepDecimal(decimal * 100, scale);
  let result = scale ? convertedDecimal : Math.round(convertedDecimal);
  result = decimal > 0 ? REOPOT_ADD + result : REOPOT_LESS + Math.abs(result);
  return isNaN(decimal) ? NA : result + PERCENT;
};

/**
 * 格式化百分比（四舍五入）
 * @param {*需要格式化的百分比小数} decimal
 * @param {*} scale
 */
export const fmtPercentNoMark = (decimal, scale) => {
  if (decimal === null || decimal === false || isNaN(decimal)) {
    return NA;
  }
  if (decimal === 0) {
    return 0;
  }
  let convertedDecimal = keepDecimal(decimal * 100, scale);
  return scale ? convertedDecimal : Math.round(convertedDecimal);
};

/**
 * 最多保留N位小数
 * @param {*} decimal
 * @param {*} scale
 */
export const keepDecimal = (decimal, scale, keepBit) => {
  if (decimal === null || decimal === false || isNaN(decimal)) {
    return NA;
  }
  if (decimal === 0) {
    return 0;
  }
  let scaleTmp = scale >= 0 ? scale : -1; // 默认保留1位小数
  // scale = scale >= 0 ? scale : 0;// 默认保留1位小数
  let decimalTmp = parseFloat(decimal, 10);
  let decimalStr = String(decimal);
  let finalDecimal =
    scaleTmp >= 0 && decimalStr.indexOf('.') > -1
      ? (decimalTmp += 0.000000000001).toFixed(scaleTmp)
      : decimal;
  return keepBit ? finalDecimal : parseFloat(finalDecimal, 10);
  // return scale >= 0 ? decimal.toFixed(scale) : decimal;
};

/**
 * 添加百万方法  M
 * @param {*} decimal
 * @param {*} scale
 */
export const getMillion = (decimal, scale, unit) => {
  if (decimal === null || decimal === false || isNaN(decimal)) {
    return NA;
  }
  if (decimal === 0) {
    return 0;
  }
  let scaleTmp, decimalTmp;
  if (decimal >= 100000) {
    if (unit === 'notShow') {
      scaleTmp = scale >= 0 ? scale : 1; // 默认保留1位小数
      decimalTmp = parseFloat(decimal, 10);
      decimalTmp += 0.000000000001;
      // let decimalStr = String(decimal);
      return (decimalTmp / 1000000).toFixed(scaleTmp);
    }
    scaleTmp = scale >= 0 ? scale : 1; // 默认保留1位小数
    decimalTmp = parseFloat(decimal, 10);
    decimalTmp += 0.000000000001;
    // let decimalStr = String(decimal);
    return (decimalTmp / 1000000).toFixed(scaleTmp) + MILLION;
  } else if (decimal >= 1000 < 100000) {
    return fmtThousand(decimal, 0);
  }
  return decimal;
};

/**
 * 判断数组或者对象是否是空
 * @param obj
 */
export const isEmptyObject = (obj) => {
  for (const key in obj) {
    return false; //返回false，不为空对象
  }
  return true; //返回true，为空对象
};

/**
 * 字符串截位
 * @param {*需要截取的字符串}str
 * @param {*结束截位的索引} end
 * @param {*开始截位的索引} begin
 */
export const strSub = (str, end, begin) => {
  let beginTmp;
  if (typeof str === 'string' && str.constructor === String) {
    beginTmp = !begin || begin <= 0 ? 0 : begin;
    if (!end || end <= 0 || str.length <= end) {
      return str;
    }

    return str.substring(beginTmp, end) + '...'; //返回true，为空对象
  }
  return typeof str;
};
/**
 * 添加单位格式化方法  过千0.00K 过十万 0.00M，过亿0.00B
 * @param {*} decimal
 */
export const transNum = (decimal, scale) => {
  // console.log(scale);
  // let scaleUse = scale === undefined ? 2 : scale;
  if (decimal === null || decimal === false || isNaN(decimal)) {
    return NA;
  }
  if (decimal === 0) {
    return 0;
  }
  let decimalTmp;
  let res = '';
  if (decimal > 0 && decimal < 1000) {
    res = fmtThousand(decimal, 2);
  } else if (decimal >= 1000 && decimal < 1000000) {
    decimalTmp = parseFloat(decimal, 10);
    decimalTmp += 0.000000000001;
    // res = keepDecimal(decimalTmp / 1000, scaleUse) + FMT_MARK.THOUNDS;
    res = keepDecimal(decimalTmp / 1000, 2) + THOUNDS;
  } else if (decimal >= 1000000 && decimal < 1000000000) {
    decimalTmp = parseFloat(decimal, 10);
    decimalTmp += 0.000000000001;
    // res = keepDecimal(decimalTmp / 1000000, scaleUse) + FMT_MARK.MILLION;
    res = keepDecimal(decimalTmp / 1000000, 2) + MILLION;
  } else if (decimal >= 1000000000) {
    decimalTmp = parseFloat(decimal, 10);
    decimalTmp += 0.000000000001;
    res = keepDecimal(decimalTmp / 1000000000, 2) + BILLION;
  }
  if (decimal < 0) {
    return '-' + transNum(Math.abs(decimal), scale);
  }
  return res;
};
/**
 * 变成options
 * @param {*需要转变的对象}obj
 * @param {*是否转成字符串} isString
 */
export const toOption = (obj, isString) => {
  let res = [];
  for (let key in obj) {
    res.push({
      value: isString ? key : isNaN(Number(key)) ? key : Number(key),
      name: obj[key],
    });
  }
  return res;
};
/**
 * 映射option
 */
export const optionToKey = (option, key) => {
  let res;

  for (let keys in option) {
    if (isNaN(Number(keys))) {
      if (keys === key) {
        res = option[keys];
      }
    } else if (Number(keys) === key) {
      res = option[keys];
    }
  }
  return res;
};

/**
 * 判断数据类型，包括基本类型和引用类型
 *  getType([]); // "Array" typeof []是object，因此toString返回
 *  getType('123'); // "string" typeof 直接返回
 *  getType(window); // "Window" toString返回
 *  getType(null); // "Null"首字母大写，typeof null是object，需toString来判断
 *  getType(undefined); // "undefined" typeof 直接返回
 *  getType(); // "undefined" typeof 直接返回
 *  getType(function () {}); // "function" typeof能判断，因此首字母小写
 *  getType(/123/g); //"RegExp" toString返回
 * @param {需要判断的对象} obj
 * @returns 数据类型
 */
export const getType = (obj) => {
  let type = typeof obj;
  if (type !== 'object') {
    // 先进行typeof判断，如果是基础数据类型，直接返回
    return type;
  }
  // 对于typeof返回结果是object的，再进行如下的判断，正则返回结果
  return Object.prototype.toString
    .call(obj)
    .replace(/^\[object (\S+)\]$/, '$1'); // 注意正则中间有个空格
};

export const splitByUnknownSeparators = (str) => {
  // 使用正则表达式来匹配一个或多个连续的非字母数字字符作为分隔符
  // \W 匹配任何非字母数字的字符，* 表示匹配零次或多次
  const separatorRegex = /\W+/;

  // 使用 trim() 方法去除每个分割结果两端的空白字符
  // filter(Boolean) 用于移除任何空字符串
  const parts = str
    .split(separatorRegex)
    .map((part) => part.trim())
    .filter(Boolean);

  return parts;
};


/**
 * 生成唯一ID
 * @returns {string} 唯一ID字符串
 */
export const generateUniqueId = () => {
  // 由当前时间戳+随机数生成，保证高并发下唯一性
  return (
    'uid_' +
    Date.now().toString(36) +
    '_' +
    Math.random().toString(36).substr(2, 9)
  );
};

